import { get } from "../../utils/get"
import { API_ERROR } from "../../consts/api"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function sniffError(err: any, res: any) {
  if (err) {
    // @ts-expect-error: Flow to TS migration.
    if (get(["response", "body", "status"], err) === "error") {
      const maybeMsg = get(["response", "body", "msg"], err)
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return maybeMsg || API_ERROR
    }
    return err
  }

  const maybeError = get(["body", "status"], res)
  const status = get("status", res)

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (status === 200 && maybeError === null) {
    return null
  }

  // @ts-expect-error: Flow to TS migration.
  if (maybeError === "error") {
    // @ts-expect-error: Flow to TS migration.
    if (get(["body", "code"], res) === "cannot_change_flight") {
      return get(["body", "code"], res)
    }

    const maybeMsg = get(["body", "msg"], res)
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return maybeMsg || API_ERROR
  }

  return null
}
